import { createContext, PropsWithChildren, use, useState } from 'react'

import { FormContextValues } from './interface'

export const FormContext = createContext<FormContextValues>({
  formNestedDeep: -1
})

export const FormContextProvider = ({ children }: PropsWithChildren) => {
  const { formNestedDeep } = use(FormContext)
  const [contextValues] = useState<FormContextValues>({
    formNestedDeep: formNestedDeep + 1
  })

  return <FormContext value={contextValues}>{children}</FormContext>
}
